export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

//export const url: string = "https://server-bttf.toab.org";

export const url =
	ENVIRONMENT === "development"
		? "http://10.10.220.45:9007"
		: "https://server-bttf.toab.org";

export const imgUrl = "https://m360ict.s3.ap-south-1.amazonaws.com/toab-bttf";

//======== Auth context helper ========//
export const SET_SIGNUP_DATA = "SET_SIGNUP_DATA";
export const AUTH_USER_SUCCESS = "AUTH_USER_SUCCESS";
export const AUTH_USER_FAILED = "AUTH_USER_FAILED";
export const SUPPORT_CONVERSATION_MGS_ID = "SUPPORT_CONVERSATION_MGS_ID";

// export const SET_SIGNUP_DATA = 'SET_SIGNUP_DATA';

// export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const MODAL_SHOW = "MODAL_SHOW";
export const MODAL_HIDE = "MODAL_HIDE";

export const QUERY_TAGS = [
	"Account",
	"participant",
	"Transfer",
	"Adjust",
	"Fair",
	"Winner",
	"B2BSession",
	"SessionRequest",
	"PaymentItemConfig",
	"PayableItem",
	"ChatbotKnowledgeBase",
	"Gift",
] as const;

export type TQueryTag =
	| typeof QUERY_TAGS[number]
	| `${typeof QUERY_TAGS[number]}s`;

export type TQueryKey<T = string | number> = TQueryTag | T;

export const FAIR_STATUS = ["upcoming", "ended", "cancelled"] as const;
export const SERVICE_TYPES = ["exhibitor", "visitor", "b2b"] as const;
